import { IModel, Model } from '../Model';

export const AuthOperationNames: Object = {
  Home_Index: 'Home_Index',
};

export interface IAuthOperationModel extends IModel {
  authOperationId: number;
  description: string | undefined;
}

export class AuthOperationModel extends Model implements IAuthOperationModel {
  authOperationId: number;
  description: string | undefined;

  constructor(params: Partial<IAuthOperationModel>) {
    super(params);
    const { authOperationId = 0, description = undefined } = params;

    this.authOperationId = authOperationId;
    this.description = description;
  }
}
